var EM_TAG_PLACEHOLDER = 'EM_TAG_PLACEHOLDER';
var END_EM_TAG_PLACEHOLDER = 'END_EM_TAG_PLACEHOLDER';
var calculateHighlightChunks = function calculateHighlightChunks(resultText) {
  var chunks = [];
  var beginTag = true;
  var nextTagIndex = 0;
  while (resultText.length > 0) {
    nextTagIndex = beginTag ? resultText.indexOf('<em>') : resultText.indexOf('</em>');
    if (nextTagIndex === -1) {
      chunks.push(resultText);
      break;
    }
    if (beginTag) {
      chunks.push(resultText.substring(0, nextTagIndex));
      chunks.push(EM_TAG_PLACEHOLDER);
      resultText = resultText.slice(nextTagIndex + 4);
    } else {
      chunks.push(resultText.substring(0, nextTagIndex));
      chunks.push(END_EM_TAG_PLACEHOLDER);
      resultText = resultText.slice(nextTagIndex + 5);
    }
    beginTag = !beginTag;
  }
  return chunks;
};

export { EM_TAG_PLACEHOLDER, END_EM_TAG_PLACEHOLDER, calculateHighlightChunks };
//# sourceMappingURL=highlightChunksCalculator.js.map
